var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { useEffect, useState } from 'react';
import { Button, DropdownMenu, Icon, Link, LoadingSpinner, Text } from '@paypalcorp/pp-react';
import { getProp } from '../common/utils';
import { OTP_CODE, GENERIC_ERROR, PASSWORD, PUBLIC_CREDENTIAL } from '../common/views';
import { handlePomaUserRecovery } from './common';
import ProfileBar from './ProfileBar';
import { PREFERRED_LOGIN_TYPES } from './constants';
const { PASSWORD_LOGIN } = PREFERRED_LOGIN_TYPES;
export default ({ authEventHandler, authProviderContext, challenges = [], csrf, isCookiedUser, forgetUser, isPomaUser, localizedContent, logger, options, publicCredential, setPublicCredential, sendOtpChallenge, sessionID, setView, updateAfterOtpSent, setLoginPreferenceInCookie, }) => {
    const [showSpinner, setShowSpinner] = useState(false);
    const [selectedChallengeId, setSelectedChallengeId] = useState(challenges[0] && challenges[0].challengeId);
    const [selectedMaskedPhoneNumber, setSelectedMaskedPhoneNumber] = useState(challenges[0] && challenges[0].maskedPhoneNumber);
    const [citStartTime, setCitStartTime] = useState('');
    useEffect(() => {
        setCitStartTime(Date.now());
        logger.track(`send_otp_rendered|${JSON.stringify({
            login_method: 'otp',
        })}`);
        logger.flush({ csrf, sessionID });
    }, []);
    const getPhoneOptions = () => {
        if (challenges.length > 1) {
            return (React.createElement("div", { className: "subHeading" },
                React.createElement(DropdownMenu, { options: challenges.map(({ maskedPhoneNumber, challengeId }, idx) => ({
                        primaryText: maskedPhoneNumber.replace(/X/g, '•'),
                        value: challengeId,
                        'data-testid': `option-${idx}`,
                    })), value: selectedChallengeId, "data-testid": "dropdown-menu", onChange: (e) => {
                        setSelectedChallengeId(e.target.value);
                        setSelectedMaskedPhoneNumber(challenges[e.target.selectedIndex].maskedPhoneNumber);
                    }, label: localizedContent('selectPhone') })));
        }
        else {
            return (React.createElement(Text, { size: "lg", className: "subHeading", style: { display: 'flex', alignItems: 'center', justifyContent: 'center' } },
                React.createElement(Icon, { name: "mobile" }),
                ' ',
                localizedContent('mobileWithMaskedPhoneNumber', {
                    maskedPhoneNumber: challenges[0] && challenges[0].maskedPhoneNumber.replace(/X/g, '•'),
                })));
        }
    };
    const handleSendOtpClicked = () => __awaiter(void 0, void 0, void 0, function* () {
        const startTime = Date.now();
        setShowSpinner(true);
        logger.track('send_otp_started');
        authEventHandler({ event: 'getOtpCodeClicked' });
        const response = yield sendOtpChallenge({ selectedChallengeId, selectedMaskedPhoneNumber });
        // XO Lite apps do not have the ngRL JS SDK loaded,
        // hence a captcha response can go unhandled
        // the following is a poor way to handle it so that XO can fallback
        const extensions = getProp(response, 'extensions', null);
        if (!extensions) {
            authEventHandler({
                event: response === 'invalid_ctxId' ? 'invalidCtxId' : 'unknownResponse',
                data: {
                    response,
                },
            });
        }
        const nonce = getProp(response, 'data.otp.sendOtpNotification.nonce', '');
        if (nonce) {
            logger.track('send_otp_succeeded');
            logger.track(`cpl_cit_send_otp|${JSON.stringify({
                start: citStartTime,
                tt: Date.now() - citStartTime,
                login_experience: 'OTP login Non Auto Sms',
            })}`);
            logger.track(`cpl_send_otp|${JSON.stringify({
                start: startTime,
                tt: Date.now() - startTime,
                login_experience: 'OTP login',
            })}`);
            updateAfterOtpSent({ response, selectedChallengeId, selectedMaskedPhoneNumber });
            setView(OTP_CODE);
        }
        else {
            logger.track('send_otp_failed');
            logger.track(`cpl_send_otp|${JSON.stringify({
                start: startTime,
                tt: Date.now() - startTime,
                login_experience: 'Send otp error',
            })}`);
            setView(GENERIC_ERROR);
        }
    });
    return (React.createElement(React.Fragment, null,
        showSpinner && (React.createElement("div", { className: "overlay-spinner" },
            React.createElement(LoadingSpinner, { screenReaderText: localizedContent('loading'), size: "xl" }))),
        isCookiedUser && (React.createElement(ProfileBar, { publicCredential: publicCredential, handleClickChange: (e) => __awaiter(void 0, void 0, void 0, function* () {
                e.preventDefault();
                setPublicCredential('');
                forgetUser({});
                setView(PUBLIC_CREDENTIAL);
            }), labelForChange: localizedContent('notYou') })),
        React.createElement("div", { className: !isCookiedUser ? 'slide-in' : '', style: { margin: '0 auto', marginBottom: '35px' }, id: "getLoginCodeContainer", "data-testid": "get-login-code-container" },
            React.createElement(Text, { size: "xl2", className: "heading", id: "sendOtpHeading", "data-testid": "send-otp-heading" }, localizedContent('sendOtpHeading')),
            getPhoneOptions(),
            React.createElement(Button, { onClick: handleSendOtpClicked, style: { width: '100%', margin: '5px 0 10px 0' }, id: "buttonGetLoginCode", "data-testid": "button-get-login-code" }, localizedContent('getACode')),
            React.createElement("div", { style: { marginTop: '15px' } },
                React.createElement(Link, { className: "secondaryLink", id: "linkLoginWithPassword", "data-testid": "link-login-with-password", href: "#", onClick: (e) => {
                        e.preventDefault();
                        const startTime = Date.now();
                        logger.track('send_otp_opted_out');
                        logger.track(`cpl_render_pwd_login|${JSON.stringify({
                            start: startTime,
                            tt: Date.now() - startTime,
                            login_experience: 'Hybrid Pwd Login',
                        })}`);
                        setLoginPreferenceInCookie({ csrf, sessionID, preference: PASSWORD_LOGIN });
                        if (isPomaUser) {
                            handlePomaUserRecovery({ authEventHandler, authProviderContext, email: publicCredential, options });
                        }
                        else {
                            setView(PASSWORD);
                        }
                    } }, localizedContent(isPomaUser ? 'setupPassword' : 'loginWithPasswordInstead')),
                React.createElement(Text, { size: "sm", id: "otpConsent", "data-testid": "otp-consent" }, localizedContent('otpConsent'))))));
};
